import { render, staticRenderFns } from "./jiating.vue?vue&type=template&id=1b5b87cc&scoped=true"
import script from "./jiating.vue?vue&type=script&lang=js"
export * from "./jiating.vue?vue&type=script&lang=js"
import style0 from "./jiating.vue?vue&type=style&index=0&id=1b5b87cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5b87cc",
  null
  
)

export default component.exports